

import { gql } from "@apollo/client";

export const GET_ALL_LEAGUES = gql`
  query GetAllLeagues {
    leagues(where: { l_is_active: { _eq: true }, l_deleted_at: { _is_null: true } }, order_by: { l_name: asc }) {
      l_id
      l_name
      l_type
    }
  }
`;

export const GET_TEAM_CONFERENCE = gql`
  query GetTeamConference($l_id: uuid!, $lt_category_ref_id: String!) {
    league_categories(
      where: {
        l_id: { _eq: $l_id }
        lc_deleted_at: { _is_null: true }
        lc_is_active: { _eq: true }
        lc_category_ref_id: { _eq: $lt_category_ref_id }
      }
    ) {
      lc_id
      lc_name
      lcf_id
    }
  }
`;

export const GET_TEAMS_BY_LEAGUE = gql`
  query GetTeamsByLeague($l_id: uuid!) {
    league_teams(
      where: { l_id: { _eq: $l_id }, lt_is_active: { _eq: true } }
      order_by: { lt_name: asc }
    ) {
      lt_id
      lt_name
      lt_color_code
      lt_category_ref_id
    }
  }
`;

export const GET_TEAM_CATEGORIES = gql`
  query GetTeamCategories($l_id: uuid!) {
    league_categories(
      where: {
        l_id: { _eq: $l_id }
        lc_deleted_at: { _is_null: true }
        lc_is_active: { _eq: true }
      }
      order_by: { lc_name: asc }
    ) {
      lc_id
      lc_name
      lc_alternate_name
      lc_brand_name
      lc_market_name
      lcf_id
      lc_ticketmaster_name
      lc_team_type
    }
  }
`;
export const INSERT_USER_PREFERENCE = gql`
  mutation InsertUserPreference($u_id: uuid!, $lc_id: uuid!) {
    insert_user_preference_one(
      object: {
        u_id: $u_id
        lc_id: $lc_id
      }
    ) {
      u_id
      lc_id
    }
  }
`;


export const GET_TEAM_CATEGORY_BY_PK = gql`
  query GetTeamCategoryByPk($lc_id: uuid!) {
    league_categories_by_pk(lc_id: $lc_id) {
      lc_id
      lc_name
      lc_alternate_name
      lc_brand_name
      lc_market_name
      lcf_id
    }
  }
`;

export const GET_ALL_CONFERENCES = gql`
  query GetAllConferences {
    league_conferences(
      where: { lcf_deleted_at: { _is_null: true } }
      order_by: { lcf_name: asc }
    ) {
      lcf_id
      l_id
      lcf_name
      lcf_display_order
    }
  }
`;

export const GET_ALL_CONFERENCES_WITH_DELETED = gql`
  query GetAllConferencesWithDeleted {
    league_conferences(
      order_by: { lcf_name: asc }
    ) {
      lcf_id
      l_id
      lcf_name
      lcf_display_order
      lcf_deleted_at
    }
  }
`;


export const GET_TEAM_DETAILS = gql`
query GET_TEAM_DETAILS($l_id: uuid!, $lt_category_ref_id: String!, $teamName: String!) {
  league_categories(
    where: {
      l_id: { _eq: $l_id },
      lc_deleted_at: { _is_null: true },
      lc_is_active: { _eq: true },
      _or: [
        { lc_category_ref_id: { _eq: $lt_category_ref_id } },
        { lc_name: { _eq: $teamName } }
      ]
    }
  ) {
    lc_id
    lc_name
    lc_alternate_name
    lc_brand_name
    lc_market_name
    lcf_id
  }
}
`;

// Also fix GET_LEAGUE_CONFERENCES query
export const GET_LEAGUE_CONFERENCES = gql`
  query GetLeagueConferences($l_id: uuid!) {
    league_conferences(  
      where: { l_id: { _eq: $l_id }, lcf_deleted_at: { _is_null: true } }
      order_by: { lcf_display_order: asc, lcf_name: asc }
    ) {
      lcf_id
      l_id
      lcf_name
      lcf_display_order
      lcf_created_at
      lcf_updated_at
    }
  }
`;

export const ADD_LEAGUE_CONFERENCE = gql`
  mutation AddLeagueConference($l_id: uuid!, $lcf_name: String!, $lcf_display_order: Int!) {
    insert_league_conferences_one(
      object: { l_id: $l_id, lcf_name: $lcf_name, lcf_display_order: $lcf_display_order }
    ) {
      lcf_id
      l_id
      lcf_name
      lcf_display_order
    }
  }
`;

export const UPDATE_LEAGUE_CONFERENCE = gql`
  mutation UpdateLeagueConference($lcf_id: uuid!, $lcf_name: String!, $lcf_display_order: Int!) {
    update_league_conferences_by_pk(
      pk_columns: { lcf_id: $lcf_id }
      _set: { lcf_name: $lcf_name, lcf_display_order: $lcf_display_order, lcf_updated_at: "now()" }
    ) {
      lcf_id
      lcf_name
      lcf_display_order
    }
  }
`;


export const DELETE_LEAGUE_CONFERENCE = gql`
  mutation DeleteLeagueConference($lcf_id: uuid!) {
    delete_league_conferences(
      where: { lcf_id: { _eq: $lcf_id } }
    ) {
      affected_rows
      returning {
        lcf_id
      }
    }
  }
`;



export const INSERT_LEAGUE_TEAM = gql`
  mutation InsertLeagueTeam(
    $l_id: uuid!
    $lt_name: String!
    $lt_abbreviation: String
    $lt_color_code: bpchar
    $lt_category_ref_id: String!
    $lcf_id: uuid
  ) {
    insert_league_teams_one(
      object: {
        l_id: $l_id
        lt_name: $lt_name
        lt_abbreviation: $lt_abbreviation
        lt_color_code: $lt_color_code
        lt_is_active: true
        lt_category_ref_id: $lt_category_ref_id
        lcf_id: $lcf_id
      }
    ) {
      lt_id
      lt_name
      lt_category_ref_id
      lcf_id
    }
  }
`;

export const DELETE_LEAGUE_TEAM = gql`
  mutation DeleteLeagueTeam($lt_id: uuid!) {
    delete_league_teams(where: { lt_id: { _eq: $lt_id } }) {
      affected_rows
    }
  }
`;

export const DELETE_LEAGUE_TEAM_VENUES = gql`
  mutation DeleteLeagueTeamVenues($lt_id: uuid!) {
    delete_league_team_venues(where: { lt_id: { _eq: $lt_id } }) {
      affected_rows
    }
  }
`;

export const DELETE_LEAGUE_ALTERNATIVE_TEAMS = gql`
  mutation DeleteLeagueAlternativeTeams($lt_id: uuid!) {
    delete_league_alternative_teams(where: { lt_id: { _eq: $lt_id } }) {
      affected_rows
    }
  }
`;

export const SOFT_DELETE_LEAGUE_CATEGORY = gql`
  mutation SoftDeleteLeagueCategory($lc_category_ref_id: String!) {
    update_league_categories(
      _set: { lc_deleted_at: "now()" }
      where: { lc_category_ref_id: { _eq: $lc_category_ref_id } }
    ) {
      affected_rows
    }
  }
`;
export const INSERT_LEAGUE_CATEGORY = gql`
  mutation InsertLeagueCategory(
    $l_id: uuid!
    $lc_name: String!
    $lc_category_ref_id: String!
    $lcf_id: uuid
    $lc_colour_code: String
    $lc_abbrev: String
    $lc_team_type: team_type_enum = Professional
    $lc_ticketmaster_name: String
  ) {
    insert_league_categories_one(
      object: {
        l_id: $l_id
        lc_name: $lc_name
        lc_colour_code: $lc_colour_code
        lc_abbrev: $lc_abbrev
        lc_category_ref_id: $lc_category_ref_id
        lcf_id: $lcf_id
        lc_team_type: $lc_team_type
        lc_ticketmaster_name: $lc_ticketmaster_name
        lc_alternate_name: []
        lc_brand_name: ""
        lc_market_name: ""
        lc_is_active: true
      }
    ) {
      lc_id
      lc_name
      lc_team_type
      lc_ticketmaster_name
      lc_category_ref_id
    }
  }
`;

export const UPDATE_TEAM_DETAILS = gql`
  mutation UpdateTeamDetails(
    $lc_id: uuid!
    $lc_alternate_name: jsonb
    $lc_brand_name: String
    $lc_market_name: String
    $lcf_id: uuid
  ) {
    update_league_categories_by_pk(
      pk_columns: { lc_id: $lc_id }
      _set: {
        lc_alternate_name: $lc_alternate_name
        lc_brand_name: $lc_brand_name
        lc_market_name: $lc_market_name
        lcf_id: $lcf_id 
      }
    ) {
      lc_id
      lc_name
      lc_alternate_name
      lc_brand_name
      lc_market_name
      lcf_id
    }
  }
`;

export const UPDATE_TEAM_ALTERNATE_NAMES = gql`
  mutation UpdateTeamAlternateNames($lc_id: uuid!, $lc_alternate_name: jsonb!) {
    update_league_categories_by_pk(
      pk_columns: { lc_id: $lc_id }
      _set: { lc_alternate_name: $lc_alternate_name }
    ) {
      lc_id
      lc_alternate_name
    }
  }
`;

export const UPDATE_TEAM_BRAND_MARKET = gql`
  mutation UpdateTeamBrandMarket($lc_id: uuid!, $lc_brand_name: String, $lc_market_name: String) {
    update_league_categories_by_pk(
      pk_columns: { lc_id: $lc_id }
      _set: { lc_brand_name: $lc_brand_name, lc_market_name: $lc_market_name }
    ) {
      lc_id
      lc_brand_name
      lc_market_name
    }
  }
`;

export const UPDATE_TEAM_CONFERENCE = gql`
  mutation UpdateTeamConference($lc_id: uuid!, $lcf_id: uuid) {
    update_league_categories_by_pk(
      pk_columns: { lc_id: $lc_id }
      _set: { lcf_id: $lcf_id }
    ) {
      lc_id
      lcf_id
    }
  }
`;

export const UPDATE_LEAGUE_TEAM_CONFERENCE = gql`
  mutation UpdateLeagueTeamConference($lt_id: uuid!, $lcf_id: uuid) {
    update_league_teams_by_pk(
      pk_columns: { lt_id: $lt_id }
      _set: { lcf_id: $lcf_id, lt_updated_at: "now()" }
    ) {
      lt_id
      lt_name
      lcf_id
    }
  }
`;

// ✅ Fixed: removed the non-existent 'league_conferences' field
export const GET_TEAMS_WITH_CONFERENCE = gql`
  query GetTeamsWithConference($l_id: uuid!) {
    league_teams(
      where: { l_id: { _eq: $l_id }, lt_is_active: { _eq: true } }
      order_by: { lt_name: asc }
    ) {
      lt_id
      lt_name
      lt_color_code
      lt_category_ref_id
     
    }
  }
`;

export const GET_TEAM_CONFERENCE_DETAILS = gql`
  query GetTeamConferenceDetails($lt_id: uuid!) {
    league_teams_by_pk(lt_id: $lt_id) {
      lt_id
      lt_name
      l_id
      lcf_id
    }
  }
`;